import { Expression } from "./expression";
import { Token } from "./token";
import { DateG6k } from "../date/date-g6k";

const PATTERN = /([\s!,\+\-\*\/\^%\(\)\[\]=<\>\~\&\^\|\?\:°])/g;

const lookup = {
    '+': Token.TYPE.T_PLUS,
    '-': Token.TYPE.T_MINUS,
    '/': Token.TYPE.T_DIV,
    '%': Token.TYPE.T_MOD,
    '(': Token.TYPE.T_POPEN,
    ')': Token.TYPE.T_PCLOSE,
    '[': Token.TYPE.T_SBOPEN,
    ']': Token.TYPE.T_SBCLOSE,
    '*': Token.TYPE.T_TIMES,
    '!': Token.TYPE.T_NOT,
    ',': Token.TYPE.T_COMMA,
    '=': Token.TYPE.T_EQUAL,
    '<': Token.TYPE.T_LESS_THAN,
    '>': Token.TYPE.T_GREATER_THAN,
    '~': Token.TYPE.T_CONTAINS,
    '&': Token.TYPE.T_BITWISE_AND,
    '^': Token.TYPE.T_BITWISE_XOR,
    '|': Token.TYPE.T_BITWISE_OR,
    '?': Token.TYPE.T_TERNARY,
    ':': Token.TYPE.T_TERNARY_ELSE,
    '°': Token.TYPE.T_DEGRE
};

export class ExpressionParser {

    text = [];

    parse(infix) {
        var constants = {
            'pi': new Token(Token.TYPE.T_NUMBER, Math.PI),
            'now': new Token(Token.TYPE.T_DATE, new DateG6k()),
            'today': new Token(Token.TYPE.T_DATE, new DateG6k()),
            'true': new Token(Token.TYPE.T_BOOLEAN, true),
            'false': new Token(Token.TYPE.T_BOOLEAN, false)
        };
        var expr = new Expression(infix);
        var self = this;
        // transform \\' to `
        infix = infix.replace(/\\\'/g, '`');
        // exemple:  "Personne = 'PP' && defined(Personne)" transform to "Personne = ¤1 && defined(Personne)"
        // where 1 is the index in self.text
        infix = infix.replace(/('[^']*')/g, function (match, m1, str) {
            self.text.push(m1.substr(1, m1.length - 2).replace(/`/g, "\'"));
            return "¤" + self.text.length;
        });
        // transform \\" to `
        infix = infix.replace(/\\\"/g, '`');
        // exemple:  "Personne = 'PP' && defined(Personne)" transform to "Personne = ¤1 && defined(Personne)"
        // where 1 is the index in self.text
        infix = infix.replace(/("[^"]*")/g, function (match, m1, str) {
            self.text.push(m1.substr(1, m1.length - 2).replace(/`/g, '\"'));
            return "¤" + self.text.length;
        });
        infix = this.maskDate(infix);
        var toks = infix.split(PATTERN);
        var prev = new Token(Token.TYPE.T_NOOP, 'noop');
        $.each(toks, function (t, value) {
            value = value.replace(/^\s+|\s+$/g, '');
            var matches;
            if ($.isNumeric(value)) {
                if (prev.type == Token.TYPE.T_PCLOSE)
                    expr.push(new Token(Token.TYPE.T_TIMES, '*'));
                expr.push(prev = new Token(Token.TYPE.T_NUMBER, parseFloat(value)));
            } else if (value.match(/^#\d+/)) {
                if (prev.type == Token.TYPE.T_PCLOSE)
                    expr.push(new Token(Token.TYPE.T_TIMES, '*'));
                expr.push(prev = new Token(Token.TYPE.T_FIELD, parseInt(value.substr(1), 10)));
            } else if (matches = value.match(/^¤(\d+)/)) {
                if (prev.type == Token.TYPE.T_PCLOSE)
                    expr.push(new Token(Token.TYPE.T_TIMES, '*'));
                var i = parseInt(matches[1], 10);
                expr.push(prev = new Token(Token.TYPE.T_TEXT, self.text[i - 1]));
            } else if (matches = value.match(/^D(\d{1,2})\.(\d{1,2})\.(\d{4})/)) {
                if (prev.type == Token.TYPE.T_PCLOSE)
                    expr.push(new Token(Token.TYPE.T_TIMES, '*'));
                var date = DateG6k.createFromFormat("j/n/Y", matches[1] + "/" + matches[2] + "/" + matches[3]);
                expr.push(prev = new Token(Token.TYPE.T_DATE, date));
            } else if (constants[value]) {
                if (prev.type == Token.TYPE.T_PCLOSE)
                    expr.push(new Token(Token.TYPE.T_TIMES, '*'));
                expr.push(prev = constants[value]);
            } else if (value !== "") {
                var type;
                switch (type = lookup[value] ? lookup[value] : Token.TYPE.T_IDENT) {
                    case Token.TYPE.T_EQUAL:
                        switch (prev.type) {
                            case Token.TYPE.T_NOT:
                                expr.pop();
                                type = Token.TYPE.T_NOT_EQUAL;
                                value = "!=";
                                break;
                            case Token.TYPE.T_LESS_THAN:
                                expr.pop();
                                type = Token.TYPE.T_LESS_OR_EQUAL;
                                value = "<=";
                                break;
                            case Token.TYPE.T_GREATER_THAN:
                                expr.pop();
                                type = Token.TYPE.T_GREATER_OR_EQUAL;
                                value = ">=";
                                break;
                        }
                        break;
                    case Token.TYPE.T_CONTAINS:
                        if (prev.type == Token.TYPE.T_NOT) {
                            expr.pop();
                            type = Token.TYPE.T_NOT_CONTAINS;
                            value = "!~";
                            break;
                        }
                    case Token.TYPE.T_BITWISE_AND:
                        if (prev.type == Token.TYPE.T_BITWISE_AND) {
                            expr.pop();
                            type = Token.TYPE.T_LOGICAL_AND;
                            value = "&&";
                        }
                        break;
                    case Token.TYPE.T_BITWISE_OR:
                        if (prev.type == Token.TYPE.T_BITWISE_OR) {
                            expr.pop();
                            type = Token.TYPE.T_LOGICAL_OR;
                            value = "||";
                        }
                        break;
                    case Token.TYPE.T_TIMES:
                        if (prev.type == Token.TYPE.T_TIMES) {
                            expr.pop();
                            type = Token.TYPE.T_POW;
                            value = "**";
                        }
                        break;
                    case Token.TYPE.T_PLUS:
                        if (prev.isOperator() || prev.isComparator() || prev.isBeforeFunctionArgument())
                            type = Token.TYPE.T_UNARY_PLUS;
                        break;

                    case Token.TYPE.T_MINUS:
                        if (prev.isOperator() || prev.isComparator() || prev.isBeforeFunctionArgument())
                            type = Token.TYPE.T_UNARY_MINUS;
                        break;

                    case Token.TYPE.T_POPEN:
                        switch (prev.type) {
                            case Token.TYPE.T_IDENT:
                                prev.type = Token.TYPE.T_FUNCTION;
                                break;

                            case Token.TYPE.T_NUMBER:
                            case Token.TYPE.T_DATE:
                            case Token.TYPE.T_BOOLEAN:
                            case Token.TYPE.T_TEXT:
                            case Token.TYPE.T_ARRAY:
                            case Token.TYPE.T_PCLOSE:
                                expr.push(new Token(Token.TYPE.T_TIMES, '*'));
                                break;
                        }
                        break;

                    case Token.TYPE.T_SBOPEN:
                        t = expr.pop();
                        expr.push(new Token(Token.TYPE.T_FUNCTION, 'get'));
                        expr.push(new Token(Token.TYPE.T_POPEN, '('));
                        expr.push(t);
                        type = Token.TYPE.T_COMMA;
                        value = ',';
                        break;

                    case Token.TYPE.T_SBCLOSE:
                        type = Token.TYPE.T_PCLOSE;
                        value = '(';
                        break;

                }
                expr.push(prev = new Token(type, value));
            }
        });
        return expr;
    }

    maskDate(infix) {
        var re = new RegExp(DateG6k.regexp, "g");
        return infix.replace(re, "D" + DateG6k.replacement);
    }

}
